/**************************************************
 * Nombre:       Seccion_Leads
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {usuarioContext} from "../../App";
import {obtenerSaldo} from "../../CodNegocio/Saldos/obtenerSaldo";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";
import {ESTADOSCAMPANAS, ESTADOSLEAD} from "../../Constantes";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TEXTO,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {ManageSearch} from "@mui/icons-material";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Lead from "../Dialogos/Dialogo_Lead";


const Seccion_Leads = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [usuario, setUsuario] = useState({})
    const [numCampanas, setNumCampanas] = useState(0)
    const [numSaldo, setNumSaldo] = useState(0)
    const [cargar, setCargar] = useState(false)
    const [w, setWheres] = useState([where('idUsuario', '==', cData.usuario.id)])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'leads', wheres: w})
    const {Dialogo: DialogoVer, abrir: abrirVer} = useDialogo({
        Componente: Dialogo_Lead,
        titulo: 'Detalle del Lead',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrirVer(data)
                break
            default :
            //abrir(data)
        }
    }


    const realizado = () => {
        console.log('realiza')
        setCargar(!cargar)
    }

    const obtenerDatos = async () => {

        const idUsuario = cData.usuario.id
        let numSaldo = await obtenerSaldo({idUsuario: idUsuario})
        setNumSaldo(numSaldo)

        let w = [where('estado', '==', ESTADOSCAMPANAS[1].nombre)]
        const numCampanas = await contarWheres({coleccion: 'campanas', wheres: w})
        setNumCampanas(numCampanas)


    }

    useEffect(() => {

        if (cData.usuario) {
            setUsuario(cData.usuario)
        }

        obtenerDatos().then((data) => {
        })


    }, [cData, cargar]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <DialogoVer/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={4}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: 6, px: sCell ? 0 : 4}}>
                    <Tabla_Filtro
                        nombre={'Leads'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Leads


const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre',],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Pais',
        direccion: 'left',
        propiedad: 'pais',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'celular',
        direccion: 'left',
        propiedad: 'celular',
        titulo: 'correo',
        tipo: CASILLA_TITULO_DATO
    },
    {
        nombre: 'Interes',
        direccion: 'left',
        propiedad: 'numero',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSLEAD
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]

